import { lazy, FC, Suspense, useState } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { MasterLayout } from "../../_jutemplate/layout/MasterLayout";
import TopBarProgress from "react-topbar-progress-indicator";
import { getCSSVariableValue } from "../../_jutemplate/assets/ts/_utils";

// redux
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "../../setup";

// component
import { DashboardPage } from "../modules/dashboard/DashboardPage";

// lazy component
const ContentPage = lazy(() => import('../modules/content/pages/ContentRootPage'))
const SurveyRootPage = lazy(() => import('../modules/survey/pages/SurveyRootPage'))
const MediaRootPage = lazy(() => import('../modules/media/pages/MediaRootPage'))
const EventRootPage = lazy(() => import('../modules/event/pages/EventRootPage'))
const UserRootPage= lazy(() => import('../modules/user/pages/UserRootPage'))
const DiseaseDetectionRootPage= lazy(() => import('../modules/disease-detection/pages/DiseaseDetectionRootPage'))
const DiseaseAndPestRootPage= lazy(() => import('../modules/disease-pest/pages/DiseaseAndPestRootPage'))
const ProductsRootPage= lazy(() => import('../modules/products/pages/ProductsRootPage'))
const GenericGroupRootPage= lazy(() => import('../modules/generic-group/pages/GenericGroupRootPage'))

const PrivateRoutes = () => {
  const [islogin, setIslogin] = useState<any>({});
  


  /////////////////

  const isAuthorized: any = useSelector<RootState>(
    ({ auth }) => auth.user,
    shallowEqual
  );
  console.log(isAuthorized);

  // useEffect(() => {
  //   if (isAuthorized) {
  //     console.log(isAuthorized)
  //     setIslogin(isAuthorized)
  //   }
  // }, [isAuthorized])

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path="auth/*" element={<Navigate to="/dashboard" />} />
        <Route path="dashboard" element={<DashboardPage />} />

        {/* start other Pages New routing */}

        <Route
          path="/content/*"
          element={
            <SuspensedView>
              <ContentPage/>
            </SuspensedView>
          }
        />

        <Route
          path="/survey/*"
          element={
            <SuspensedView>
              <SurveyRootPage/>
            </SuspensedView>
          }
        />

        <Route
          path="/media/*"
          element={
            <SuspensedView>
              <MediaRootPage/>
            </SuspensedView>
          }
        />

        <Route
          path="/event/*"
          element={
            <SuspensedView>
                <EventRootPage/>
            </SuspensedView>
          }
        />

       <Route
          path="/user/*"
          element={
            <SuspensedView>
                <UserRootPage/>
            </SuspensedView>
          }
        />

       <Route
          path="/disease-detection/*"
          element={
            <SuspensedView>
                <DiseaseDetectionRootPage/>
            </SuspensedView>
          }
        />

       <Route
          path="/generic-group/*"
          element={
            <SuspensedView>
                <GenericGroupRootPage/>
            </SuspensedView>
          }
        />

        <Route
          path="/disease-pest/*"
          element={
            <SuspensedView>
                <DiseaseAndPestRootPage/>
            </SuspensedView>
          }
        />

        <Route
          path="/products/*"
          element={
            <SuspensedView>
                <ProductsRootPage/>
            </SuspensedView>
          }
        />

  

        {/* Page Not Found */}
        <Route path="*" element={<Navigate to="/error/404" />} />
      </Route>
    </Routes>
  );
};

const SuspensedView: FC<{ children: React.ReactNode }> = ({ children }) => {
  const baseColor = getCSSVariableValue("--bs-primary");
  TopBarProgress.config({
    barColors: {
      "0": baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  });
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>;
};

export { PrivateRoutes };
